export function flattenBlocksForMainLayout(layout: Layout[]) {
    if (!layout || layout.length === 0) return []

    const isBlockHidden = (block: any) => {
        const flag = block?.isHidden
        return flag === true || flag === "true" || flag === 1 || flag === "1"
    }

    return layout.reduce((acc, curr) => {
        if (curr.columns && curr.columns.length > 0) {
            curr.columns.forEach((col) => {
                if (!col.blocks || col.blocks.length === 0) return

                const visibleBlocks = col.blocks.filter((block) => !isBlockHidden(block))
                acc.push(...visibleBlocks)
            })
        }
        return acc
    }, [])
}
